import { Button, Card, CardContent } from "@mui/material";
import { Spin } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { PsLabel } from "../../components";
import PsContext from "../../context";
import { _CHECK_USER_LOGIN } from "../../models/loginModel";
import { formToObject, KS_LOGO } from "../../utils";

const UserLoginPage = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _CHECK_USER_LOGIN(formToObject(form)).then((res) => {
      if (res.status == "1") {
        axios.defaults.headers.common["Api-Token"] = res.token;
        context.updateLogin(res.token, res.data, res.permissions || []);
      } else {
        context.setAlertMsg(res.message || "Invalid Login");
        setLoader(false);
      }
    });
  };

  if (context.userLogged == "1") {
    return <Navigate to="/app" replace />;
  } else {
    return (
      <>
        <section>
          <div style={{ marginTop: "calc(20vh)" }} />
          <div className="container">
            <Row>
              <Col md={{ span: 4, offset: 4 }}>
                <Spin spinning={loader}>
                  <Card>
                    <CardContent>
                      <Row>
                        <Col md={12}>
                          <img src={KS_LOGO} className="w-100" />
                        </Col>
                      </Row>
                      <h5 className="text-center border-bottom pb-3 mb-3 mt-3">
                        Sign In
                      </h5>
                      <Form
                        action=""
                        method="post"
                        noValidate
                        validated={validated}
                        className="p-2"
                        onSubmit={handleFormSubmit}
                      >
                        <Row>
                          <Col md={12}>
                            <PsLabel text="Username" required />
                            <Form.Control
                              type="text"
                              name="username"
                              placeholder="Username"
                              className="fw-bold"
                              autoFocus={true}
                              autoComplete="off"
                              required
                            />
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col md={12}>
                            <PsLabel text="Password" required />
                            <Form.Control
                              type="password"
                              name="password"
                              placeholder="Password"
                              className="fw-bold"
                              autoComplete="off"
                              required
                            />
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col md={12}>
                            <Button type="submit" variant="contained" fullWidth>
                              Sign In
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </CardContent>
                  </Card>
                </Spin>
              </Col>
            </Row>
          </div>
        </section>
      </>
    );
  }
};
export default UserLoginPage;
